import React, { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import Skeleton from '../../components/common/Skeleton/Skeleton';

const ContactResultsList = ({ results, isSearching, onContactSelect, onShowCreateDrawer, hasSearched }) => {
  // Asegurar que results siempre sea un array
  const safeResults = Array.isArray(results) ? results : [];
  const alertShownRef = useRef(false);

  // Mostrar sweet alert si se buscó y no hay resultados
  useEffect(() => {
    // Solo mostrar si:
    // 1. Se ha buscado
    // 2. No está buscando actualmente
    // 3. No hay resultados
    // 4. El alert no se ha mostrado ya
    if (hasSearched && !isSearching && safeResults.length === 0 && !alertShownRef.current) {
      alertShownRef.current = true;
      Swal.fire({
        icon: 'info',
        title: 'No se encontraron contactos',
        text: 'No encontramos contactos que coincidan con tu búsqueda.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#232D4F'
      });
    }

    // Resetear el flag cuando hay resultados o cuando se está buscando
    if (safeResults.length > 0 || isSearching) {
      alertShownRef.current = false;
    }
  }, [hasSearched, isSearching, safeResults.length]);

  if (isSearching) {
    return (
      <div className="contact-results">
        <div className="results-header">
          <Skeleton width="250px" height="22px" borderRadius="8px" />
        </div>
        
        <div className="contact-cards">
          {[1, 2].map(i => (
            <div key={i} className="contact-card">
              <div className="contact-info">
                <div className="contact-name">
                  <Skeleton width="180px" height="20px" borderRadius="6px" />
                </div>
                
                <div className="contact-details">
                  <div style={{ marginBottom: '0.5rem' }}>
                    <Skeleton width="200px" height="16px" borderRadius="6px" />
                  </div>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <Skeleton width="220px" height="16px" borderRadius="6px" />
                  </div>
                  <div>
                    <Skeleton width="180px" height="16px" borderRadius="6px" />
                  </div>
                </div>
              </div>
              
              <div className="contact-actions">
                <Skeleton width="100px" height="36px" borderRadius="8px" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // No mostrar nada si no se ha buscado o no hay resultados
  if (safeResults.length === 0) {
    return null;
  }

  return (
    <div className="contact-results">
      <div className="results-header">
        <h4>Resultados de búsqueda ({safeResults.length})</h4>
      </div>
      
      <div className="contact-cards">
        {safeResults.map((contact) => (
          <div key={contact.id} className="contact-card">
            <div className="contact-info">
              <div className="contact-name">
                <h5>{`${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'Sin nombre'}</h5>
              </div>
              
              <div className="contact-details">
                <div className="detail-item">
                  <span className="label">CUIL:</span>
                  <span className="value">{contact.cuil || 'No especificado'}</span>
                </div>
                
                <div className="detail-item">
                  <span className="label">Correo:</span>
                  <span className="value">{contact.email || 'No especificado'}</span>
                </div>
                
                <div className="detail-item">
                  <span className="label">Telefono 1:</span>
                  <span className="value">{contact.phone || 'No especificado'}</span>
                </div>
                
                {contact.phone2 && (
                  <div className="detail-item">
                    <span className="label">Telefono 2:</span>
                    <span className="value">{contact.phone2}</span>
                  </div>
                )}

                {contact.address && (
                  <div className="detail-item">
                    <span className="label">Direccion:</span>
                    <span className="value">{contact.address}</span>
                  </div>
                )}
              </div>
            </div>
            
            <div className="contact-actions">
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={() => onContactSelect(contact)}
              >
                Seleccionar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactResultsList;
